<div class="form-row m-0">
    <div class="form-row position-relative w-100">
        <mat-form-field appearance="outline" class="w-100">
            <input type="text" placeholder="Select Roe" matInput [ngModel]="inputLabel" [formControl]="roeControl"
                [matAutocomplete]="roes" />
            <mat-autocomplete #roes="matAutocomplete" (optionSelected)="emitRoe($event.option.value)">
                <mat-option *ngFor="let option of roeOptions | async" [value]="option">
                    {{ option.code }}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
    </div>
</div>